const TransactionStatuses = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  PREPENDING: 'PRE-PENDING',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
};

export default TransactionStatuses;



// WEBPACK FOOTER //
// ./src/data/static/transactionStatuses.js